import { render, staticRenderFns } from "./Challenge6.vue?vue&type=template&id=9f5c3aa4&scoped=true&lang=pug&"
import script from "./Challenge6.vue?vue&type=script&lang=ts&"
export * from "./Challenge6.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5c3aa4",
  null
  
)

export default component.exports